import { tsInitVueGrid } from './js-utils'
import OspeParticipantGrid from './vue-components/ospe/ospe-participant-grid.vue'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.ospe-application.ospe-participants')) {
    const participantGridEl = document.querySelector('div[data-is="OspeParticipantGrid"]')
    if (participantGridEl instanceof HTMLElement) {
      const props: any = {}
      if (participantGridEl.dataset.withCheckmarks == 'false') {
        props.withCheckmarks = false
      }
      window.ospeParticipantGrid = tsInitVueGrid(OspeParticipantGrid, participantGridEl, props)
    }
  }
})
